"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasWith = exports.hasKey = exports.has = void 0;

var _isMatch = require("../is-match/is-match");

var _any = require("../any/any");

var _is = require("../is/is");

/**
 * Check if value is in array
 *
 * @param   {mixed}    arg     What to search for
 * @param   {Array}    source  Haystack
 *
 * @return  {boolean}  True if has, false otherwise
 *
 * @tag Array
 * @signature (value: Function|mixed )( source: Array ): boolean
 *
 * @example
 * has(2)([1, 2])
 * // => true
 *
 * has(3)([1, 2])
 * // => false
 *
 * has(elm => elm.id === 1)([{}, {id: 1}])
 * // => true
 */
var has = function has(arg) {
  return typeof arg === "function" ? (0, _any.any)(arg) : (0, _any.any)(function (val) {
    return val === arg;
  });
};

exports.has = has;

var hasKey = function hasKey(key) {
  return function (source) {
    return (0, _is.is)(source) && Object.prototype.hasOwnProperty.call(source, key);
  };
};

exports.hasKey = hasKey;

var hasWith = function hasWith(subset) {
  return has((0, _isMatch.isMatch)(subset));
};

exports.hasWith = hasWith;